module.exports = __webpack_public_path__ + "img/2.ff92e9b7.png";